// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__1uKDq","alert":"SettungsInbox_alert__2zzLa"};